import "core-js/modules/es.array.includes";

/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import { getStore } from '../../store/store';
import getString from '../../strings/get-string';
import { showConfirmation } from '../../store/device-feature/actions';
import { execute } from '../../native-app-bridge/native-app-bridge';
import { getCallbackPromise, HAS_PERMISSION_CALLBACK_NAME } from './callbacks';
import getPermissionAPI from '../support/get-permission-api';
import parseResult from '../support/parse-result';

var hasFeature = function hasFeature(response) {
  var result = parseResult(response);
  var featureAvailable = result.rearFacing || result.frontFacing;
  var policyEnabled = !result.isCameraDisabledByPolicy;

  var _getCallbackPromise = getCallbackPromise(),
      reject = _getCallbackPromise.reject,
      requestedFeature = _getCallbackPromise.requestedFeature;

  var cameraPermissionEnhancedWorkflow = false;

  if (window.mwfGlobals.checkDepositCameraPermissionEnhancedWorkflow && ['check deposit', 'check-deposit'].includes(window.mwfGlobals.platformName.toLowerCase()) || window.mwfGlobals.transferMoneyCameraPermissionEnhancedWorkflow && window.mwfGlobals.platformName.toLowerCase() === 'selfpay' || window.mwfGlobals.billpayCameraPermissionEnhancedWorkflow && window.mwfGlobals.platformName.toLowerCase() === 'bill pay') {
    cameraPermissionEnhancedWorkflow = true;
  }

  if (featureAvailable) {
    if (policyEnabled) {
      // confirm permission to use feature
      execute(getPermissionAPI(), {
        requestedFeature: requestedFeature
      }, HAS_PERMISSION_CALLBACK_NAME);
    } else if (!cameraPermissionEnhancedWorkflow) {
      // feature disabled by policy
      getStore().dispatch(showConfirmation({
        message: getString('core.camera.access'),
        showLink: true,
        onConfirm: reject
      }));
    }
  } else {
    // device does not have camera support
    getStore().dispatch(showConfirmation({
      message: getString('core.camera.no.support'),
      showLink: false,
      onConfirm: reject
    }));
  }
};

export default hasFeature;